import React, { Component } from "react";

const BlogContext = React.createContext();

class BlogProvider extends Component {
  state = {
    blogs: []
  };

  getBlog = slub => {
    let tempBlogs = [...this.state.blogs];
    const blog = tempBlogs.find(blog => blog.slub === slub);
    return blog;
  };

  render() {
    return (
      <BlogContext.Provider
        value={{
          ...this.state,
          getBlog: this.getBlog
        }}
      >
        {this.props.children}
      </BlogContext.Provider>
    );
  }
}

const BlogConsumer = BlogContext.Consumer;

export function withBlogsConsumer(Component) {
  return function ConsumerWrapper(props) {
    return (
      <BlogConsumer>
        {value => <Component {...props} context={value} />}
      </BlogConsumer>
    );
  };
}

export { BlogProvider, BlogConsumer, BlogContext };
